import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iResetPasswordState {
    email: string;
    new_password: string;
    isLoading: boolean;
    response: any;
    message: string;
}

const initialState: iResetPasswordState = {
    email: '',
    new_password: '',
    isLoading: false,
    response: [],
    message: ""
}

export const postResetPasswordAPI = createAsyncThunk(
    'POST_RESET_PASSWORD',
    async (user: { email: string; new_password: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/force-reset-password/'
            

            const response = await axiosInstance.patch(
                `${djangoEndpoint}${pathParam}`,
                {
                    email: user.email,
                    new_password: user.new_password,
                },
                {
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const resetPasswordSlice = createSlice({
    name: 'resetPassword',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postResetPasswordAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(postResetPasswordAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(postResetPasswordAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.email = '';
                state.new_password = '';
                state.response = action.payload;
            });
    }
});

export default resetPasswordSlice.reducer;